// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__lLI2m","fadeInUp":"LandingPage_fadeInUp__G4miN"};